kombi.alert = function (parent, message, type, clear_all) {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = [
        `<div class="alert alert-${type} fade show alert-dismissible" role="alert">`,
        `   <div>${message}</div>`,
        '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
        '</div>'
    ].join('')
    if (clear_all) {
        parent.replaceChildren(wrapper)
    } else {
        parent.append(wrapper)
    }

    setTimeout(() => {
        wrapper.querySelector(".btn-close").click()
    }, 5000)
}

kombi.popFloatAlert = function (message, type) {
    type = type === 'error' ? 'danger' : type;
    const floatMessageBox = document.getElementById('FloatMessageContainer');
    floatMessageBox.innerHTML = `
                            <div class="alert alert-${type} float-alert text-center" role="alert">
                                ${message}
                            </div>
                        `;
}